import { createStyles } from '@svg/antd/es/theme/utils';
import { titleStyles } from './title';
import { listStyles } from './list';

const useStyles = () => {
    const titleStylesResult = titleStyles();
    const listStylesResult = listStyles();

    return {
        styles: {
            ...titleStylesResult.styles,
            ...listStylesResult.styles
        }
    };
};

export default useStyles;